import { render, staticRenderFns } from "./payment4.vue?vue&type=template&id=2117ad50&scoped=true&"
import script from "./payment4.vue?vue&type=script&lang=js&"
export * from "./payment4.vue?vue&type=script&lang=js&"
import style0 from "./payment4.vue?vue&type=style&index=0&id=2117ad50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2117ad50",
  null
  
)

export default component.exports